const routes = [
  {
    path: '/billing',
    name: 'billing',
    redirect: 'billing/payment-methods',
    component: () =>
      import(/* webpackChunkName: 'about' */ '@/views/billing/BillingMain.vue'),

    children: [
      {
        path: 'payment-methods',
        name: 'billing-payment-methods',
        component: () =>
          import(
            /* webpackChunkName: 'billing' */ '@/views/billing/PaymentMethods.vue'
          )
      },

      {
        path: 'invoices',
        name: 'billing-invoices',
        component: () =>
          import(
            /* webpackChunkName: 'billing' */ '@/views/billing/BillingInvoices.vue'
          )
      },

      {
        path: '/invoices/:invoiceId',
        name: 'invoice-details',
        component: () =>
          import(
            /* webpackChunkName: 'invoice' */ '@/views/billing/Invoice.vue'
          )
      },

      {
        path: '/payment-methods/add-card',
        name: 'billing-add-card',
        component: () =>
          import(
            /* webpackChunkName: 'billing' */ '@/views/billing/AddCard.vue'
          )
      }
    ]
  }
]

export default routes
